export const ChromeExt = {
  P: {
    color: 'inactive',
    margin: '0 0 X2',
    text: '{{ learn.install.chromeExt | polyglot }}'
  },
  Link: {
    target: '_blank',
    borderWidth: 'hairline',
    borderStyle: 'solid',
    borderColor: 'transparent',
    display: 'inline-block',
    href: '#',
    transition: 'opacity A defaultBezier, border A defaultBezier',
    round: 'radiusControl',
    opacity: '.9',
    ':hover': {
      opacity: '1',
      borderColor: 'inactive.25'
    },
    Img: {
      display: 'block',
      height: 'C1',
      src: 'chrome-ext.png'
    }
  }
}
